export default __webpack_public_path__ + "static/42q-28f51f46d7be11fd8975ab8020015088.png";